import api from './api';

export const buildRegistrationPayload = (email, password, name = '') => {
  const fullName = name.trim();
  const emailLocalPart = email.split('@')[0] || 'reader';
  const usernameSource = fullName || emailLocalPart;
  let username = usernameSource
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  if (username.length < 3) {
    username = `${username || emailLocalPart}-user`
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  return {
    email,
    password,
    username: username.slice(0, 50),
    full_name: fullName || null,
  };
};

// Auth service methods
export const authService = {
  // Login with email and password
  login: async (email, password) => {
    const response = await api.post('/auth/login', null, {
      params: {
        email,
        password,
      },
    });
    return response.data;
  },

  // Register new user
  register: async (email, password, name = '') => {
    const response = await api.post('/auth/register', buildRegistrationPayload(email, password, name));
    return response.data;
  },

  // Get current user profile
  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  // Logout
  logout: async () => {
    const response = await api.post('/auth/logout');
    return response.data;
  },

  // Request magic link
  requestMagicLink: async (email) => {
    const response = await api.post('/auth/magic-link', { email });
    return response.data;
  },

  // Verify magic link token
  verifyMagicLink: async (token) => {
    const response = await api.get(`/auth/magic-link/verify?token=${token}`);
    return response.data;
  },

  // Get CSRF token
  getCsrfToken: async () => {
    const response = await api.get('/csrf-token');
    return response.data;
  },
};

export default authService;
